<template>
  <div class="delyfk-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="评价状态">
              <el-select v-model="searchForm.mark" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="待评价" :value="0" />
                <el-option label="已评价" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户名称"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.custname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户电话"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.custtel}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请回访时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="整体满意度"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#9aaabf" v-if="scope.row.mark!==1">N/A</span>
                      <span style="color:#E6A23C" v-if="scope.row.mark===1">{{scope.row.satis}}.0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="服务态度"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#9aaabf" v-if="scope.row.mark!==1">N/A</span>
                      <span style="color:#E6A23C" v-if="scope.row.mark===1">{{scope.row.attitude}}.0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="及时处理"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#9aaabf" v-if="scope.row.mark!==1">N/A</span>
                      <span style="color:#E6A23C" v-if="scope.row.mark===1">{{scope.row.timely}}.0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="评价状态"
                    width="120"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="warning">待评价</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1">已评价</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-star-off" v-if="scope.row.mark===0" @click.stop="evaluate(scope.row)">立即评价</el-button>
                      <el-button size="mini" icon="el-icon-edit" v-if="scope.row.mark===1" @click.stop="detail(scope.row)">修改评价</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="售后评价"
      :visible.sync="editVisible"
      width="460px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="整体满意度" prop="satis">
          <el-rate v-model="editForm.satis" :texts="rateTexts" show-text text-color="#ff9900" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="服务态度" prop="attitude">
          <el-rate v-model="editForm.attitude" :texts="rateTexts" show-text text-color="#ff9900" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="及时处理" prop="timely">
          <el-rate v-model="editForm.timely" :texts="rateTexts" show-text text-color="#ff9900" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="反馈建议" prop="content">
          <el-input type="textarea" placeholder="请输入反馈建议内容" v-model="editForm.content"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="修改售后评价"
      :visible.sync="detailVisible"
      width="460px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="评价人" prop="opername">
          <div>{{editForm.opername}}</div>
        </el-form-item>
        <el-form-item label="评价时间" prop="time">
          <div>{{editForm.time}}</div>
        </el-form-item>
        <el-form-item label="整体满意度" prop="satis" style="color:#99a9bf">
          <el-rate v-model="editForm.satis" :texts="rateTexts" show-text text-color="#ff9900" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="服务态度" prop="attitude">
          <el-rate v-model="editForm.attitude" :texts="rateTexts" show-text text-color="#ff9900" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="及时处理" prop="timely">
          <el-rate v-model="editForm.timely" :texts="rateTexts" show-text text-color="#ff9900" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="反馈建议" prop="content">
          <el-input type="textarea" placeholder="请输入反馈建议内容" v-model="editForm.content"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即修改</el-button>
          <el-button @click="detailVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerAfterVisit, dealerAfterVisitOper } from '@/api/dealer'

export default {
  name: 'delshhf',
  computed: {
    user: getUser
  },
  data() {
    const valSatis = (rule, value, callback) => {
      if (value === null || value === '' || value === undefined || value === 0 || value === '0') {
        callback(new Error('请选择整体满意度评分'))
      } else {
        callback()
      }
    }
    const valAttitude = (rule, value, callback) => {
      if (value === null || value === '' || value === undefined || value === 0 || value === '0') {
        callback(new Error('请选择服务态度评分'))
      } else {
        callback()
      }
    }
    const valTimely = (rule, value, callback) => {
      if (value === null || value === '' || value === undefined || value === 0 || value === '0') {
        callback(new Error('请选择及时处理评分'))
      } else {
        callback()
      }
    }
    return {
      searchForm: {
        search: '',
        mark: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      rateTexts: ['极差 1.0', '失望 2.0', '一般 3.0', '满意 4.0', '惊喜 5.0'],
      editForm: {
        orderid: '',
        satis: null,
        attitude: null,
        timely: null,
        content: '',
        time: '',
        opername: ''
      },
      editRules: {
        satis: [{ required: true, trigger: 'change', validator: valSatis }],
        attitude: [{ required: true, trigger: 'change', validator: valAttitude }],
        timely: [{ required: true, trigger: 'change', validator: valTimely }],
        content: [{ required: false, message: '请在这里填写不满意的原因', trigger: 'blur' }]
      },
      detailVisible: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    setNotSatisfied() {
      console.info(this.editForm)
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid,
        mark: this.searchForm.mark
      }
      getDealerAfterVisit(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/delorder/' + row.orderid })
    },
    detail(row) {
      this.editForm.orderid = row.orderid
      this.editForm.satis = row.satis
      this.editForm.attitude = row.attitude
      this.editForm.timely = row.timely
      this.editForm.content = row.content
      this.editForm.time = row.deltime
      this.editForm.opername = row.opername
      this.detailVisible = true
    },
    evaluate(row) {
      this.editForm.orderid = row.orderid
      this.editForm.satis = null
      this.editForm.attitude = null
      this.editForm.timely = null
      this.editForm.content = ''
      this.editForm.time = ''
      this.editForm.opername = ''
      this.editVisible = true
    },
    subEdit(formName) {
      if (this.editForm.attitude > 0 && this.editForm.satis > 0 && this.editForm.timely > 0) {
        if (this.editForm.attitude < 3 || this.editForm.satis < 3 || this.editForm.timely < 3) {
          this.editRules.content[0].required = true
        } else {
          this.editRules.content[0].required = false
        }
      } else {
        this.editRules.content[0].required = false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.userid,
              orderid: this.editForm.orderid,
              satis: this.editForm.satis,
              attitude: this.editForm.attitude,
              timely: this.editForm.timely,
              content: this.editForm.content
            }
            dealerAfterVisitOper(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.editVisible = false
              this.detailVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.delyfk-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
